module.exports = __webpack_public_path__ + "img/top.0507232c.png";